import {useRef} from 'react';
import {CHANNEL_TALK} from '@/router';

const CHANNEL_TALK_ELEMENT_ID = 'ch-plugin';

/** 1:1 문의(채널톡 메신저)를 연다. 플러그인을 쓸 수 없으면 채널톡 홈을 새 창으로 연다. */
export const openChannelTalk = () => {
  if (window.ChannelIO) {
    window.ChannelIO('showMessenger');
  } else {
    window.open(CHANNEL_TALK, '_blank');
  }
};

export const useChannelTalk = () => {
  const pluginRef = useRef<HTMLElement>();

  const hideChannelTalk = () => {
    const pluginElement = document.getElementById(CHANNEL_TALK_ELEMENT_ID);
    if (pluginElement) {
      pluginElement.style.setProperty('display', 'none', 'important');
      pluginRef.current = pluginElement;
    }
  };

  const showChannelTalk = () => {
    if (pluginRef.current) {
      pluginRef.current.style.removeProperty('display');
      pluginRef.current = undefined;
    }
  };

  return {
    hideChannelTalk,
    showChannelTalk,
  };
};
